<script>
    import { Container } from 'sveltestrap'

    let windowWidth = 0
</script>

<style>
    :global(.bg-light-color) {
        background-color: #f2f2f2 !important;
    }
</style>

<svelte:window bind:innerWidth={windowWidth} />

<Container class="pt-5 px-4 clearfix bg-light-color">
    <uiView />
</Container>
